import React from "react";

const Loader = () => {
  return (
    <div className="flex items-center justify-center h-[100vh]">
      <div className="mainLoader"></div>
    </div>
  );
};

export default Loader;
